<template>
  <div class='ml-10'>
    <div class='mb-2 d-flex align-center justify-end'>
      <v-btn text x-small class='ml-3' color='primary' depressed
             @click='downloadData'
             style='transform: translateX(-10px);width: 68px'>
        <template v-if="!downloadBtnLoading">
          <v-icon size='20'>{{ icons.mdiDownload }}</v-icon>
          <span class='ml-1'>下载</span>
        </template>

        <template v-else>
          <v-progress-circular
            class="mr-1"
            :size="18"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </template>
      </v-btn>
      <v-btn text x-small class='ml-3' color='primary' depressed
             @click='refresh'
             style='transform: translateX(-10px)'>
        <v-icon size='20'>{{ icons.mdiRefresh }}</v-icon>
        <span class='ml-1'>刷新</span>
      </v-btn>
    </div>
    <vxe-table
      style='z-index: 2'
      ref='dataTable'
      class='scroll-table'
      border
      resizable
      :height='tableHeight'
      show-header-overflow
      show-overflow
      :loading='tableLoading'
      size='small'
      :row-config='{isHover: true}'
      :data='dataList'
      @filter-change='search'
      :filter-config='{ remote: true }'
    >
      <vxe-column field='createBy' title='Member' :filters="[{ data: '' }]" width='200'>
        <template #filter='{ $panel, column }'>
          <vxe-input v-for='(option, index) in column.filters' :key='index' v-model='option.data'
                     @input='$panel.changeOption($event, !!option.data, option)'>
          </vxe-input>
        </template>
      </vxe-column>
      <vxe-column field='nameOfJob' title='Resource Level'
                  :filters="[{label:'Accenture Leadership',value:'Accenture Leadership'},{label:'5',value:'5'},{label:'6',value:'6'},{label:'7',value:'7'}
                    ,{label:'8',value:'8'},{label:'9',value:'9'},{label:'10',value:'10'}  ,
                    {label:'11',value:'11'},{label:'12',value:'12'},{label:'13',value:'13'},
                  {label:'Intern',value:'Intern'}]" :filter-multiple='true'
                  width='140'>
      </vxe-column>
      <vxe-column field='queryContent' title='Query Content' width='240'>
      </vxe-column>
      <vxe-column field='queryCategory' title='Category' width='120'>
      </vxe-column>
      <vxe-column field='answerContent' title='Answer' min-width="180">
      </vxe-column>
      <vxe-column field='domain' title='Domain' width='150'>
      </vxe-column>
      <vxe-column
        title='source'
        field='source'
        width='100'
        :filters="[
          {label:'网页版',value:'page'},
          {label:'teams',value:'teams'}
        ]"
        :filter-multiple='true'
      >
        <template #default='{ row }'>
          <span v-if="row.source === 'page'">网页版</span>
          <span v-else>teams</span>
        </template>
      </vxe-column>
      <vxe-column field='aiResponseBody' width='150' title='AI返回值' sortable
                  show-header-overflow show-overflow />
      <vxe-column field='aiCallStartTime' width='150' title='AI调用开始时间' sortable
                  show-header-overflow show-overflow />
      <vxe-column field='aiCallEndTime' width='150' title='AI调用结束时间' sortable
                  show-header-overflow show-overflow />
      <vxe-column field='aiCallSecondDiff' width='120' title='AI耗时(秒)' sortable
                  show-header-overflow show-overflow />
      <vxe-column field='createTime' width='150' title='Create Time' sortable
                  show-header-overflow show-overflow />
      <vxe-column title='Evaluation' fixed="right" width='170'>
        <template #default='{ row }'>

          <v-tooltip bottom>
            <template v-slot:activator='{ on, attrs }'>
              <v-btn
                :color="'EXCELLENT'===row.evaluation? 'green':''"
                outlined
                x-small
                class='mr-1'
                @click="evaluationFunc(row,'EXCELLENT')"
                v-bind='attrs'
                v-on='on'>
                很好
              </v-btn>
            </template>
            <span>Excellent</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator='{ on, attrs }'>
              <v-btn
                :color="'FAIR'===row.evaluation? 'yellow':''"
                outlined
                x-small
                v-bind='attrs'
                v-on='on'
                class='mr-1'
                @click="evaluationFunc(row  ,'FAIR')">
                一般
              </v-btn>
            </template>
            <span>Fair</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator='{ on, attrs }'>
              <v-btn
                :color="'POOR'===row.evaluation? 'red':''"
                outlined
                x-small
                class='mr-1'
                @click="evaluationFunc(row ,'POOR')"
                v-bind='attrs'
                v-on='on'>
                糟糕
              </v-btn>
            </template>
            <span>Poor</span>
          </v-tooltip>
        </template>
      </vxe-column>
    </vxe-table>
    <vxe-pager
      :current-page='pagerOption.pageNum'
      :page-size='pagerOption.pageSize'
      :total='pagerOption.totalData'
      :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
      :page-sizes='[10, 20, 50, 100]'
      @page-change='changePerPage'
    />
  </div>
</template>
<script>
import { getQueryAnswerPageList, evaluationById, downloadQueryContentList } from '../api/index'
import {
  mdiThumbUp,
  mdiThumbDown,
  mdiRefresh,
  mdiDownload
} from '@mdi/js'
import moment from 'moment'

export default {
  data() {
    return {
      tableLoading: false,
      dataList: [],
      pagerOption: {
        pageNum: 1,
        pageSize: 20,
        totalData: 0,
      },
      icons: {
        mdiThumbUp, mdiThumbDown, mdiRefresh, mdiDownload,
      },
      searchParams: {
        nameOfJobList: [],
        createBy: null,
        sourceList: [],
      },
      screenHeight: 0,
      tableHeight: 0,
      downloadBtnLoading: false
    }
  },
  created() {
    this.getPageList()
  },
  mounted() {
    this.getScreenHeight()
    // 监听窗口大小变化事件
    window.addEventListener('resize', this.getScreenHeight)
  },
  beforeDestroy() {
    // 组件销毁前移除事件监听器
    window.removeEventListener('resize', this.getScreenHeight)
  },
  methods: {
    async downloadData() {
      this.downloadBtnLoading = true

      const res = await downloadQueryContentList({ ...this.searchParams })
      const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const a = document.createElement('a')
      const url = window.URL.createObjectURL(blob)

      a.href = url
      a.download = `提问记录_${moment().format('YYYY-MM-DD')}.xlsx`
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(url)

      this.downloadBtnLoading = false
    },
    refresh() {
      this.pagerOption.pageNum = 1
      this.pagerOption.pageSize = 20
      this.getPageList()
    },
    search(params) {
      const { filters } = params
      console.log('🚀 ~ search ~ filters:', filters)
      this.searchParams.createBy = null
      this.searchParams.nameOfJobList = []
      filters.forEach(item => {
        if (item.property === 'nameOfJob') {
          this.searchParams.nameOfJobList = item.values
        } else if (item.property === 'createBy') {
          this.searchParams.createBy = item.datas[0]
        } else if (item.property === 'source') {
          this.searchParams.sourceList = item.values
        }
      })
      console.log(this.searchParams)
      this.getPageList()
    },
    changePerPage(currentPage) {
      this.pagerOption.pageNum = currentPage.currentPage
      this.pagerOption.pageSize = currentPage.pageSize
      this.getPageList()
    },
    async getPageList() {
      this.tableLoading = true
      const {
        data: {
          code,
          data,
        },
      } = await getQueryAnswerPageList({ ...this.pagerOption, ...this.searchParams })
      if (code === 200) {
        this.dataList = data.records
        this.pagerOption.totalData = data.total
      }
      this.tableLoading = false
    },
    async evaluationFunc(row, status) {
      row.evaluation = status
      console.log(row)
      const params = {
        id: row.answerId,
        evaluation: status,
      }
      const res = await evaluationById(params)
      if (res.data.code === 200) {
        this.$message.success('评价成功')
      } else {
        this.$message.error(res.data.msg)
      }
    },
    getScreenHeight() {
      this.screenHeight = window.innerHeight
      this.tableHeight = this.screenHeight - 64 - 50 - 50
    },
  },
}
</script>
